export default __webpack_public_path__ + "static/media/hmd_background_xl1.6a3f4756.jpg";